module.exports = __webpack_public_path__ + "capt.png?dabbd2d79f8c8f8940b76403e0720d3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/capt.png
// module id = 47
// module chunks = 0